import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export const Diners = ({ size, className, id }) => {
  let ratio = size / 100;

  let width = size,
    height = 63 * ratio;

  let _attributes = {
    width: width || 100,
    height: height || 63,
    viewBox: "0 0 100 63"
  };

  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(className);
  }

  return (
    <svg {..._attributes}>
      <g transform="translate(-775 -407)">
        <rect width="100" height="63" transform="translate(775 407)" fill="none" />
        <g transform="translate(800.353 418.268)">
          <circle cx="19.718" cy="19.718" r="19.718" transform="translate(0.855 1.058)" fill="#fff" />
          <path d="M251.511,416.725a20.463,20.463,0,0,1-20.6-20.245c0-12.178,9.3-20.6,20.6-20.6h5.3c11.165,0,21.357,8.418,21.357,20.6,0,11.14-10.192,20.245-21.357,20.245Zm.046-39.157a18.7,18.7,0,1,0,18.7,18.7A18.7,18.7,0,0,0,251.557,377.568Zm-4.245,29.755V385.207a11.841,11.841,0,0,0,0,22.116Zm16.1-11.056A11.863,11.863,0,0,0,255.8,385.2v22.122A11.863,11.863,0,0,0,263.409,396.266Z" transform="translate(-230.912 -375.879)" fill="#003b87" />
        </g>
      </g>
    </svg>
  );
};

Diners.defaultProps = {
  size: 100,
  className: "",
  id: ""
};

Diners.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
